import React, { Component } from 'react'
import moment from 'moment'

import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'
import Controls from '../common/controls'
import * as dateFormatting from './date_formatting'
import ICalendarLink from "react-icalendar-link";

class CoachingMatch extends Component {
  constructor(props) {
    super(props)
    this.props.updateActivePage(3)
    this.next = this._next.bind(this)
    this.state = {
      inspirator: null,
      sessions: []
    }
    document.title = "Coaching Session Confirmed"
  }

  _next() {
    return this.props.next(this.props.match.path)
  }

  async componentDidMount() {
    let inspiratorInfo = await this.props.getInspiratorInfo(this.props.history)
    if (!inspiratorInfo) return ;

    let events = await this.props.getEvents(this.props.history)
    if (!events || events.length === 0 || events.length === undefined) {
      return ;
    }
    events = events.filter(event => event.eventType === 'program_orientation' || event.eventType === 'coaching_session')
    let sessions = []
    for (let i = 0; i < events.length; ++i) {
      sessions.push(moment(events[i].startTime))
    }
    
    this.setState({
      sessions,
      inspirator: {
        image: inspiratorInfo.inspiratorPictureUrl,
        name: inspiratorInfo.inspiratorName,
        about: inspiratorInfo.aboutMe
      }
    })
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus() 
    window.scrollTo(0, 0)
  }

  displayScheduledSessions () {
    if(this.state.sessions.length !== 0) {
      let sessionsDisplay = this.state.sessions.map(session => 
        <div key={session.valueOf()} className="booked-sessions">
          <div className="coaching-sessions-subheader">
            {`${dateFormatting.completeDatePrettyPrint(session)} (${dateFormatting.getTimezoneShort(session)})`}
          </div>
          {this.displayCalendar(session)}
        </div>
      )
      return (
        <div>
          <div className="coaching-sessions-subheader">
            Your scheduled sessions:
            <span>{sessionsDisplay}</span>
          </div>
          <div className="coaching-break"> <br aria-hidden="true" /></div>
        </div>
      )
    }
  }

  displayCalendar(session) {
    var eventEnd = moment(session).add(20, 'minutes')
    const event = {
      title: "Live Newtopia Coaching Session",
      description: "If for any reason you need to change or cancel your scheduled session, please reach out to our Client Care team at 1 888 639 8181 or clientcare@newtopia.com. \\n\\nYours in good health,\\nThe Newtopia Team",
      startTime: session.format(),
      endTime: eventEnd.format(),
      location: "video chat or call"
    }
    return (
        <ICalendarLink filename="Live Newtopia Coaching Session.ics" className="calendar-link" event={event}>
          <img className="calendar-logo" aria-label={`This coaching session is ${dateFormatting.completeDatePrettyPrint(session)} (${dateFormatting.getTimezoneShort(session)}), click to download your calendar`} src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/987f4686-03a5-43ee-8674-9354c2885f3c.png" alt="calendar" />
          <p className="download-link">
            Add to Calendar
          </p>
        </ICalendarLink>
    )
  }

  displayInspiratorInfo() {
    const { inspirator } = this.state
    if (inspirator && inspirator.image && inspirator.about) {
      return (
        <div>
          <p className="match-info">Meet your Inspirator:</p>
          <div className="inspirator-info">
            <img className="inspirator-photo" src={this.state.inspirator.image} alt="inspirator"/>
            <p className="inspirator-about">{`Hello, I'm ${this.state.inspirator.name}! ${this.state.inspirator.about}`}</p>
          </div>
        </div>
      )
    }
  }

  render() {
    return (
      <div id="coaching-match">
        <AriaMessage message="Navigated to coaching match page" />
        <Title>This Step is Important - Create Your Personal Profile</Title>
        <div className="container">
          <div className="coaching-match-header">
            Let's get to know you. Now would be perfect!
          </div>
          <div className="coaching-break"> <br aria-hidden="true"/></div>
          <div className="coaching-break"> <br aria-hidden="true"/></div>
          <div className="next-button-match">
            <Controls className="coaching-button" nextLabel="CREATE PERSONAL PROFILE" next={this.next} />
          </div>
          <div className="coaching-match-subheader">
            Your Welcome Kit, complete with tools and a smart scale will be sent once you complete your personal profile.
          </div>
          <div className="coaching-break"> <br aria-hidden="true"/></div>
          <div className="coaching-break"> <br aria-hidden="true"/></div>
          <p className="match-info">You will receive confirmation emails of your scheduled coaching sessions.</p>
          <p className="match-info">Click the calendar icons below to add them to your calendar now.</p>
          {this.displayScheduledSessions()}
          {this.displayInspiratorInfo()}
        </div>
      </div>
    )
  }
}

export default CoachingMatch